<div *ngIf="data">
  <app-client-side-data-table
    [id]="'workspace-documents-table-id'"
    [selectFieldName]="'id'"
    [data]="data"
    [columns]="columns"
    [sort]="sort"
    [eventService]="workspaceDocumentsEventsService"
    [refreshIt]="refreshDataTable"
    [paging]="false"
  ></app-client-side-data-table>
</div>
